// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"dc794116","453":"ce519ffd"}[chunkId] + ".chunk.js";
};